import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";

export const WhatsAppFloat = () => (
  <motion.a
    data-testid="whatsapp-floating-cta"
    href={waLink("Namaste Aradhana Jewellers! I'd like to know more about your collections.")}
    target="_blank"
    rel="noreferrer"
    initial={{ opacity: 0, scale: 0 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 4.2, type: "spring", stiffness: 200 }}
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.92 }}
    className="animate-gold-pulse fixed bottom-6 right-6 z-[80] flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-[#F9F0BE] via-[#D4AF37] to-[#C59B27] text-black shadow-2xl"
    aria-label="Chat on WhatsApp"
  >
    <MessageCircle size={22} />
  </motion.a>
);
